import { useRef } from 'react';
import { NJButton } from '@engie-group/fluid-design-system-react';
import { UMFormStyles } from '../../urbanmap/_components';
import { EmptyState } from './EmptyState';
import { HomeRail } from './HomeChrome';
import { CURRENT_USER } from './homeModel';
import { UMR } from './planTokens';
import type { ProjectSummary } from './types';
import { CompletedProjectsTable } from './CompletedProjectsTable';
import { ProjectCardWireframes } from './ProjectCardWireframes';

interface Props {
  projects: ProjectSummary[] | undefined;
  loading: boolean;
  error: boolean;
  onCreate: () => void;
  onOpen: (id: string) => void;
  flash: (message: string) => void;
}

export function HomePage({ projects, loading, error, onCreate, onOpen, flash }: Props) {
  const mine = (projects ?? []).filter((p) => !p.archived && p.owner === CURRENT_USER);
  const contentRef = useRef<HTMLElement>(null);

  return (
    <div style={{ display: 'flex', height: '100%', background: UMR.white }}>
      <UMFormStyles />
      <HomeRail onHome={() => contentRef.current?.scrollTo({ top: 0, behavior: 'smooth' })} flash={flash} />
      <div className="pcv3-home-content">
      <main ref={contentRef} className="pcv3-home-main">
        <div style={{ margin: '0 auto' }}>
          {loading && <EmptyState icon="hourglass_top" title="Chargement des projets…" />}
          {error && <EmptyState icon="error" title="Impossible de charger les projets">Réessayez dans quelques instants.</EmptyState>}

          {projects && projects.length === 0 && (
            <EmptyState icon="folder_off" title="Aucun projet">
              <span>Créez un premier projet : choisissez un périmètre, les bâtiments UrbanMap y seront copiés.</span>
              <NJButton label="Nouveau projet" icon="add" onClick={onCreate} />
            </EmptyState>
          )}

          {projects && projects.length > 0 && (
            <>
              <ProjectCardWireframes projects={projects} onCreate={onCreate} onOpen={onOpen} flash={flash} />

              <CompletedProjectsTable
                projects={mine}
                onOpen={onOpen}
              />
            </>
          )}
        </div>
      </main>
      </div>
    </div>
  );
}
